import { render } from "./tabLawyer.vue?vue&type=template&id=c40c3324"
import script from "./tabLawyer.vue?vue&type=script&lang=js"
export * from "./tabLawyer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/migration_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__